import * as urlParse from 'url-parse';
import * as i0 from "@angular/core";
export var SSO_TOKEN_PARAMETER = 'i3jwt-token';
export var SSO_EXIT_PARAMETER = 'i3jwt-exit';
export var SSO_REALM_PARAMETER = 'realm';
export var SSO_REDIRECTURL_PARAMETER = 'redirectUrl';
var AuthSSOProvider = /** @class */ (function () {
    function AuthSSOProvider() {
    }
    AuthSSOProvider.prototype.redirectoToSSO = function (ssoUrl, ssoRealm) {
        var _a;
        var urlParts = this.parse(ssoUrl);
        var currentLocation = window.location.href;
        Object.assign(urlParts.query, (_a = {}, _a[SSO_REALM_PARAMETER] = ssoRealm, _a[SSO_REDIRECTURL_PARAMETER] = currentLocation, _a));
        window.location.href = urlParts.toString();
    };
    AuthSSOProvider.prototype.checkSSOAuthenticationSuccess = function () {
        return this.getToken() ? true : false;
    };
    AuthSSOProvider.prototype.getToken = function () {
        var urlParts = this.parse(location.href);
        return urlParts.query[SSO_TOKEN_PARAMETER];
    };
    AuthSSOProvider.prototype.parse = function (url) {
        var baseUrl = {}; // Ensures that the parsing is independent from the current location of the browser.
        var parseQueryString = true;
        return urlParse(url, baseUrl, parseQueryString);
    };
    AuthSSOProvider.ngInjectableDef = i0.defineInjectable({ factory: function AuthSSOProvider_Factory() { return new AuthSSOProvider(); }, token: AuthSSOProvider, providedIn: "root" });
    return AuthSSOProvider;
}());
export { AuthSSOProvider };
